import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import { fetchCatalog, formatPrice } from '../lib/supabaseClient'

const SLUG_TO_DEALER_PRICE = {
  'ss-h8pro':  15775,
  'ss-da15s':  49530,
  'ss-da18s':  58240,
  'ss-r10a':   25512,
  'ss-r12a':   31785,
  'ss-r15a':   35750,
  'ss-j4015a': 20475,
  'ss-j4012a': 18330,
  'ss200m-uv': 26950,
  'ss-280a':   16500,
}

export default function DealerDashboard() {
  const { user, isDealer, isAdmin, signOut } = useAuth()
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchCatalog()
      .then(({ products: prods }) => {
        const enriched = prods.map((p) => {
          const retail = p.price || 0
          const dealer = SLUG_TO_DEALER_PRICE[p.slug] || Math.round(retail * 0.65)
          return {
            ...p,
            retail_price: retail,
            dealer_price: dealer,
          }
        })
        setProducts(enriched)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-gray-200 border-t-gray-900 rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500">Загрузка...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-2">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              {isAdmin ? 'Административная панель' : isDealer ? 'Личный кабинет' : 'Личный кабинет'}
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              {isAdmin ? 'Администратор' : isDealer ? 'Дилер' : 'Пользователь'} — {user?.email}
            </p>
          </div>
          <button
            onClick={async () => {
              await signOut()
              window.location.href = '/'
            }}
            className="text-sm text-red-600 hover:text-red-800 font-medium px-4 py-2 border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
          >
            Выйти
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-white rounded-xl p-4 border border-gray-100">
            <p className="text-xs text-gray-400 uppercase mb-1">Компания</p>
            <p className="font-medium">{user?.user_metadata?.company || 'Test Dealer Company'}</p>
          </div>
          <div className="bg-white rounded-xl p-4 border border-gray-100">
            <p className="text-xs text-gray-400 uppercase mb-1">Email</p>
            <p className="font-medium">{user?.email}</p>
          </div>
          <div className="bg-white rounded-xl p-4 border border-gray-100">
            <p className="text-xs text-gray-400 uppercase mb-1">Статус</p>
            <p className="font-medium text-green-600">Активен</p>
          </div>
        </div>

        <h2 className="text-xl font-bold text-gray-900 mb-4">Прайс-лист дилера</h2>
        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Товар</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Категория</th>
                  <th className="text-right px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Розница</th>
                  <th className="text-right px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Ваша цена</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {products.map((p) => (
                  <tr key={p.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <Link to={`/product/${p.slug}`} className="font-medium text-gray-900 hover:text-gray-600">
                        {p.name}
                      </Link>
                      <p className="text-xs text-gray-400">{p.sku}</p>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">{p.categories?.name}</td>
                    <td className="px-4 py-3 text-right">
                      <span className="text-gray-400 line-through text-sm">{formatPrice(p.retail_price)}</span>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className="font-bold text-red-600">{formatPrice(p.dealer_price)}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
